// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"93cea235","787":"f9154694"}[chunkId] + ".chunk.js";
};